import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import * as appConfig from "appConfig";

import styles from "./AudioInterface.module.scss";
import { useUi } from "@jelly/lesson";
import { messages } from "../../Preparations.messages";

type AudioInterfaceModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;

export const AudioInterfaceModal: React.FC<AudioInterfaceModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props}>
      <div className={styles.slide}>
        {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
        <SpatialCarousel showBreadcrumbs controlsPosition="bottom">
          {[
            <div key={1} className={styles.carouselItem}>
              <div className={styles.content}>
                <h2 className={styles.title}>{formatMessage(messages.audioInterfaceModalTitle)}</h2>
                <ui.Scrollbars>
                  <div className={styles.description}>
                    <p>{formatMessage(messages.audioInterfaceModalSlide1Description)}</p>
                  </div>
                </ui.Scrollbars>
              </div>
              <div className={styles.divider}></div>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.audioInterfaceModalSlide1Content) }}></p>
            </div>,
            <div key={2} className={styles.carouselItem}>
              <div className={styles.content}>
                <h2 className={styles.title}>{formatMessage(messages.audioInterfaceModalTitle)}</h2>
                <ui.Scrollbars>
                  <div className={styles.description}>
                    <p
                      dangerouslySetInnerHTML={{ __html: formatMessage(messages.audioInterfaceModalSlide2Description) }}
                    ></p>
                  </div>
                </ui.Scrollbars>
              </div>
              <div className={styles.divider}></div>
              <img
                className={styles.image}
                src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/preparations/4.png`}
                alt="feature-comparison"
              />
            </div>,
            <div key={3} className={styles.carouselItem}>
              <div className={styles.content}>
                <h2 className={styles.title}>{formatMessage(messages.audioInterfaceModalTitle)}</h2>
                <ui.Scrollbars>
                  <div className={styles.description}>
                    <p
                      dangerouslySetInnerHTML={{ __html: formatMessage(messages.audioInterfaceModalSlide3Description) }}
                    ></p>
                  </div>
                </ui.Scrollbars>
              </div>
              <div className={styles.divider}></div>
              <img
                className={styles.image}
                src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/preparations/5.png`}
                alt="feature-comparison"
              />
            </div>,
          ]}
        </SpatialCarousel>
      </div>
    </ui.Modal>
  );
};
